import angular from 'angular';

import chartGraphComponent from './chart.component';

export default angular.module('dbm.dashboard.components.graph.chart', [])
.component('dbmChartGraph', chartGraphComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/chart/index.js